<template>
  <div
    class="border border-2 border-mint-200 px-1 py-0 px-md-2 py-md-1 px-lg-3 py-lg-2 bg-white-to-mint-100 rounded-sm mx-md-1 mx-sm"
    :class="{ 'bg-white-to-red-100 border-red-200': red }"
  >
    <span class="text-base font-weight-bold text-mint-600" :class="{ 'text-red': red }">{{
      item
    }}</span>
  </div>
</template>

<script>
export default {
  name: 'NumberBox',
  props: {
    item: {},
    red: {
      type: Boolean,
      default: false
    }
  }
}
</script>
